import { NotificationItem } from "./notification-item";

export function NotificationList({ notifications }: any) {
  return (
    <div className="space-y-4 px-2">
      {notifications.map((notification: any) => (
        <NotificationItem key={notification.id} notification={notification} />
      ))}
    </div>
  );
}
